import React, { Component } from 'react';

import './RejectBatch.scss';
import {
    EmvioButton as Button
} from '@nexio/emvio-form-components';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import { toggleModal } from '../Modal/modalActions';
import { connect } from 'react-redux';
import { rejectPayoutBatch } from './payoutBatchActions';
import { getPayoutBatch, getIsRejectLoading, getIsRejectSuccess } from './payoutBatchEntity';
import _ from 'lodash';
import { payoutBatchShape } from '../../utils/propTypes';
import { doesPropExistAndHasItChanged } from '@nexio/emvio-util-app';

export class RejectBatch extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    static propTypes = {
        onCancel: PropTypes.func,
        onToggleModal: PropTypes.func.isRequired,
        rejectBatch: PropTypes.func.isRequired,
        enabledProp: PropTypes.string,
        payoutBatch: payoutBatchShape,
        isRejectBatchLoading: PropTypes.bool,
        isRejectSuccess: PropTypes.bool
    };

    handleOnSubmit = () => {
        this.props.rejectBatch(_.get(this.props.payoutBatch, 'id'));
    };

    handleOnCancel = (e) => {
        e.preventDefault();
        this.props.onToggleModal('rejectBatch');
    };

    componentDidUpdate(prevProps) {
        if (doesPropExistAndHasItChanged(prevProps, this.props, 'isRejectSuccess') && this.props.isRejectSuccess) {
            this.props.onToggleModal('rejectBatch');
        }
    }

    render() {
        return (
            <Modal uniqueModalName="rejectBatch" title="Confirm Your Decision" className="reject-modal">
                <div className="reject-warning-container">
                    <div className="reject-warning-content">
                        <div className="reject-message-container">
                            This deletes the batch report and cannot be undone. If you accidentally reject a batch,
                            you
                            would need to re-run the batch and generate a new report.
                        </div>
                        <div className="form-button-row">
                            <Button
                                className="cancel"
                                onClick={this.handleOnCancel}>
                                Cancel
                            </Button>
                            <Button
                                className="reject"
                                onClick={this.handleOnSubmit}>
                                {this.props.isRejectBatchLoading ? 'Loading...' : 'Reject Batch'}
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        payoutBatch: getPayoutBatch(state),
        isRejectBatchLoading: getIsRejectLoading(state),
        isRejectSuccess: getIsRejectSuccess(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onToggleModal: () => dispatch(toggleModal('rejectBatch')),
        rejectBatch: (batchId) => dispatch(rejectPayoutBatch(batchId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RejectBatch);
